import { DamagedParts } from "pages/VehicleAnalysis/types";

import client from "./client";

export const getDamagedParts = (sessionId: string, clientId: string): Promise<DamagedParts> =>
  client
    .get(`/client/${clientId}/session/${sessionId}/damagedParts`, {
      headers: { session_id: sessionId },
    })
    .then(({ data }) => data);
